/*
 * @Author: your name
 * @Date: 2021-01-21 11:09:31
 * @LastEditTime: 2021-03-01 15:34:22
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /xdap-h5/src/mixin/feishu-client.mixin.js
 */
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      _isFeishuClient: state => state.tenantModule.xdapplatform
    }),
    _isFeishuLark() {
      let isFeishu = window.navigator.userAgent.match(/(LarkLocale)/i)
      return isFeishu !== null && isFeishu !== undefined
    }
  }
}
